import "./App.scss";

import renderRoutes from "./router";

function App() {
  return renderRoutes();
}

export default App;
